import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { ButtonBlue, ButtonDarkBlue } from '../../HouseStyle/Components/Buttons';

const InstallModal = ({ showModal, app, onClose, onInstall, installing }) => {
    const handleInstall = () => {
        onInstall(app);
    };

    const handleClose = () => {
        onClose();
    };

    if (!app) return null;

    return (
        <Modal
            show={showModal}
            onHide={handleClose}
            className="colormodals"
            size="lg"
            centered
        >
            <Modal.Header className="modalTop justify-content-between">
                <h4 className="mb-0 ms-1 fw-semibold">App installeren</h4>
                <button variant="transparent" className='btn' onClick={handleClose}>
                    <FontAwesomeIcon icon={faXmark} className="closeModal" />
                </button>
            </Modal.Header>
            <Modal.Body className="modalCenter d-flex flex-column">
                <div className="text-center">
                    {app.logo && (
                        <div className="mb-4" style={{ 
                            display: 'flex', 
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '200px'
                        }}>
                            <img 
                                src={app.logo} 
                                alt={app.name} 
                                style={{ 
                                    maxHeight: '100%', 
                                    maxWidth: '100%',
                                    objectFit: 'contain'
                                }} 
                            />
                        </div>
                    )}
                    
                    <h4 className="mb-3">{app.name}</h4>
                    
                    <p className="mb-4">
                        Weet je zeker dat je <strong>{app.name}</strong> wilt installeren?
                    </p>
                    
                    {app.description && (
                        <p className="text-muted mb-4">{app.description}</p>
                    )}
                    
                    {app.categories && app.categories.length > 0 && (
                        <div className="mb-4">
                            <small className="text-muted">Categorieën: </small>
                            {app.categories.map((category, index) => (
                                <span key={category.id}>
                                    <small className="text-muted">
                                        {category.name}
                                        {index < app.categories.length - 1 && ', '}
                                    </small>
                                </span>
                            ))}
                        </div>
                    )}
                </div>            
            </Modal.Body>
            <Modal.Footer className="modalBottom">
                   <div className="d-flex justify-content-between">
                    <ButtonDarkBlue
                        text={'Annuleren'}
                        onClickFunction={handleClose}
                    />
                    <ButtonBlue
                        text={'Installeren'}
                        onClickFunction={handleInstall}
                        disabled={installing}
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default InstallModal;